var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfMenuCapsule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20.2402,
    height: 20.2385,
    viewBox: "0 0 20.2402 20.2385",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8898 1.60181L1.60057 10.891C-0.533524 13.0251 -0.533524 16.5029 1.60057 18.637C2.62861 19.6626 4.02144 20.2385 5.47356 20.2385C6.92567 20.2385 8.31851 19.6626 9.34654 18.637L18.6354 9.34738C19.1441 8.83886 19.5477 8.23508 19.8231 7.57054C20.0984 6.906 20.2402 6.19372 20.2402 5.4744C20.2402 4.75507 20.0984 4.04279 19.8231 3.37825C19.5477 2.71371 19.1441 2.10993 18.6354 1.60141C16.5001 -0.533869 13.0255 -0.533869 10.8898 1.60181ZM8.28424 17.5751C7.53806 18.3193 6.52721 18.7372 5.47336 18.7372C4.4195 18.7372 3.40866 18.3193 2.66248 17.5751C1.91703 16.8296 1.49824 15.8185 1.49824 14.7642C1.49824 13.71 1.91703 12.6989 2.66248 11.9533L7.17214 7.4433C8.47362 7.89367 9.65585 8.63368 10.6297 9.60751C11.6035 10.5813 12.3435 11.7636 12.7939 13.0651L8.28424 17.5751ZM17.5735 8.28547L13.9558 11.9028C12.8829 9.37008 10.8668 7.35413 8.33403 6.2814L11.9517 2.66372C12.3196 2.28912 12.7581 1.99113 13.2418 1.78693C13.7256 1.58274 14.2449 1.47639 14.77 1.47403C15.295 1.47168 15.8154 1.57335 16.3009 1.77319C16.7864 1.97303 17.2276 2.26707 17.5988 2.63834C17.9701 3.00961 18.2642 3.45075 18.464 3.93629C18.6638 4.42183 18.7655 4.94215 18.7632 5.4672C18.7608 5.99225 18.6544 6.51163 18.4503 6.99535C18.2461 7.47907 17.9481 7.91755 17.5735 8.28547Z",
    fill: "url(#paint0_linear_0_14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.765 2.4501C15.1736 2.30174 14.554 2.30871 13.9661 2.47032C13.3782 2.63193 12.8421 2.9427 12.4097 3.3725C12.3345 3.44086 12.274 3.52376 12.2318 3.61619C12.1897 3.70862 12.1667 3.80864 12.1643 3.91021C12.1619 4.01178 12.1801 4.11278 12.2179 4.20709C12.2556 4.30141 12.3122 4.38708 12.384 4.45892C12.4558 4.53076 12.5415 4.58728 12.6358 4.62504C12.7301 4.66281 12.8311 4.68105 12.9327 4.67864C13.0343 4.67624 13.1343 4.65325 13.2267 4.61107C13.3192 4.56888 13.4021 4.50838 13.4704 4.43322C13.7171 4.18444 14.0247 4.00469 14.3626 3.91191C14.7004 3.81912 15.0567 3.81655 15.3958 3.90444C15.492 3.93033 15.5923 3.93686 15.6909 3.92363C15.7896 3.91041 15.8846 3.8777 15.9705 3.82741C16.0564 3.77712 16.1315 3.71025 16.1913 3.63069C16.2511 3.55113 16.2945 3.46047 16.319 3.36398C16.3435 3.2675 16.3485 3.16711 16.3338 3.06865C16.3192 2.9702 16.285 2.87565 16.2335 2.7905C16.1819 2.70535 16.114 2.6313 16.0335 2.57266C15.9531 2.51401 15.8618 2.47195 15.765 2.44891V2.4501Z",
    fill: "url(#paint1_linear_0_14)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_14",
    x1: 0,
    y1: 10.1193,
    x2: 20.2402,
    y2: 10.1193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#309E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153846,
    stopColor: "#38A16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#3FA367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#46A565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384615,
    stopColor: "#4DA863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#53AA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#59AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#5FAF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692308,
    stopColor: "#65B157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#6AB353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846154,
    stopColor: "#6FB54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923077,
    stopColor: "#75B84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_14",
    x1: 12.1641,
    y1: 3.5113,
    x2: 16.342,
    y2: 3.5113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#269C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0769231,
    stopColor: "#309E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153846,
    stopColor: "#38A16A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230769,
    stopColor: "#3FA367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#46A565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384615,
    stopColor: "#4DA863"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461538,
    stopColor: "#53AA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538462,
    stopColor: "#59AC5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#5FAF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.692308,
    stopColor: "#65B157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769231,
    stopColor: "#6AB353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846154,
    stopColor: "#6FB54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923077,
    stopColor: "#75B84B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ABA47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfMenuCapsule);
export default __webpack_public_path__ + "static/media/cf-menu-capsule.cae80e2837952afcae08a3e194aeed76.svg";
export { ForwardRef as ReactComponent };